module.exports = __webpack_public_path__ + "static/media/lukko.b4af344b.svg";